export function camelize(text) {
    return text.replace(/^([A-Z])|[\s-_]+(\w)/g, function (_, p1, p2) {
        if (p2)
            return p2.toUpperCase();
        return p1.toLowerCase();
    });
}
export function slugify(text) {
    return text
        .toString()
        .toLowerCase()
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(/[^\w\-]+/g, '') // Remove all non-word chars
        .replace(/\-\-+/g, '-') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, ''); // Trim - from end of text
}
export function stripTags(text) {
    return text.replace(/(<([^>]+)>)/gi, '');
}
export function debounce(func, timeout) {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = window.setTimeout(() => {
            func(...args);
        }, timeout);
    };
}
export const getOnChangeValue = (eventOrValue) => {
    const value = typeof eventOrValue === 'string'
        ? eventOrValue
        : eventOrValue.currentTarget.value;
    return value;
};
export function throwIfDevelop(errorMsg) {
    if (process.env.NODE_ENV === 'development' ||
        process.env.NODE_ENV === 'test') {
        const msg = `${errorMsg}
NOTE: this error is only shown in developer mode`;
        throw new Error(msg);
    }
}
/**
 * used to type Array.filter functions
 * @param value
 * @returns
 */
export function notEmpty(value) {
    if (value === null || value === undefined)
        return false;
    return true;
}
//# sourceMappingURL=index.js.map